module.exports = __webpack_public_path__ + "assets/img/warrior-name-255f6be6.png";